// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-status__state[data-v-0a150adc]{font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:var(--q4s-neutral-500);margin-left:10px}.booking-status__prefix[data-v-0a150adc]{font-weight:500}", ""]);
// Exports
module.exports = exports;
